export const ShareStorageListItemMenuItem = {
  VIEWER: "VIEWER",
  EDITOR: "EDITOR",
  OWNER: "OWNER",
  SEARCH: "SEARCH",
  USER: "USER",
  REMOVE: "REMOVE"
};
